import { createContext, ReactNode, useContext, useMemo } from "react";
import { useClientSettingsContext } from "@hooks/useClientSettings";

export const BankLogoContext = createContext({ url: "" });

export const useBankLogo = () => useContext(BankLogoContext);

export type BankLogoProviderProps = { children?: ReactNode; url?: string };

export const BankLogoProvider = ({ children, url }: BankLogoProviderProps) => {
  const { client } = useClientSettingsContext();

  const bankLogo = client.assets.bankLogo;

  const contextState = useMemo(
    () => ({ url: url ?? bankLogo }),
    [url, bankLogo],
  );

  return (
    <BankLogoContext.Provider value={contextState}>
      {children}
    </BankLogoContext.Provider>
  );
};
